exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cropper-content .cropper[data-v-382a5fcc] {\n  width: 18.75rem;\n  height: 18.75rem;\n  margin: 0 auto;\n}\n.cropper-content .tip-box[data-v-382a5fcc] {\n  margin-top: 0.9375rem;\n  line-height: normal;\n  font-size: 0.875rem;\n}\n.cropper-content .tip-box .icon[data-v-382a5fcc] {\n  font-size: 1rem;\n  line-height: normal;\n  vertical-align: bottom;\n}", ""]);

// exports
